import { useState } from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { Typography, Button } from "@mui/material";
import {
  TimelineOppositeContent,
  timelineOppositeContentClasses,
} from "@mui/lab";
import localize from "../../../common/localize";
import ModalBackground from "../../../components/common/ModalBackground";
import DynamicFormReview from "../../dynamicForm/components/review/DynamicFormReview";
import { getClearBasicModel } from "../../../common/EntitiesManagement";
import { getGoogleMapsLink } from "../../../common/utils";
import DynamicFormHeaderForReport from "./report/DynamicFormHeaderForReport";

// eslint-disable-next-line arrow-body-style
const StatusChangeTimelineItem = ({
  setStatusChangeId,
  eventModel,
  timelineObj,
  isFirstOne,
  setDynamicFormModel,
  setShowDynamicFormModal,
  isForReport,
}) => {
  const handleDynamicFormClick = (dynamicForm) => {
    setStatusChangeId(timelineObj?.Id);
    if (setDynamicFormModel) {
      setDynamicFormModel(dynamicForm);
    }
    setShowDynamicFormModal(true);
  };

  return (
    <TimelineItem key={`${timelineObj?.Id}-item`}>
      <TimelineOppositeContent key={`${timelineObj?.Id}-opposite`}>
        <div className="ml-2 field_title_text">
          <Typography noWrap>
            {new Date(
              isFirstOne ? eventModel?.CreationDate : timelineObj?.ChangeDate,
            ).toLocaleString(undefined, {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            })}{" "}
          </Typography>
        </div>
      </TimelineOppositeContent>

      <TimelineSeparator key={`${timelineObj?.Id}-separator`}>
        <TimelineDot
          key={`${timelineObj?.Id}-dot`}
          sx={{
            bgcolor: isFirstOne
              ? timelineObj?.InitialStatus?.BackgroundColor
              : timelineObj?.FinalStatus?.BackgroundColor,
          }}
        />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent key={`${timelineObj?.Id}-content`}>
        <div className="flex mb-5">
          <div
            className="flex-col w-full -mt-2 border-gray-300 border-2 rounded-xl items-center content-center justify-center"
            style={{
              padding: "10px",
              minWidth: "500px",
              background: isFirstOne
                ? timelineObj?.InitialStatus?.BackgroundColor
                : timelineObj?.FinalStatus?.BackgroundColor,
              color: isFirstOne
                ? timelineObj?.InitialStatus?.ForegroundColor
                : timelineObj?.FinalStatus?.ForegroundColor,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography className="field_title_text">
                <b>
                  {isFirstOne
                    ? timelineObj?.InitialStatus?.Name
                    : timelineObj?.FinalStatus?.Name}
                </b>
              </Typography>

              {timelineObj.IsManual > 0 && (
                <Typography className="field_title_text">
                  {localize.executed_manually}
                </Typography>
              )}
            </div>

            <hr
              style={{
                borderTop: `1px solid ${
                  isFirstOne
                    ? timelineObj?.InitialStatus?.ForegroundColor
                    : timelineObj?.FinalStatus?.ForegroundColor
                }`,
              }}
            />

            <div className="flex-col mt-2 w-full">
              <Typography className="field_title_text">
                <b>{localize.reported_by}: </b>
                {`${
                  isFirstOne ? eventModel?.CreatedBy : timelineObj.CreatedBy
                }`}
              </Typography>
              {!isFirstOne && timelineObj?.Observation?.length > 0 && (
                <div className="flex">
                  <Typography className="field_title_text">
                    <b>{`${localize.observations}:`}</b>
                  </Typography>
                  <div className="ml-2">
                    <label
                      className="field_title_text"
                      style={{ whiteSpace: "pre-wrap" }}
                    >{`${timelineObj.Observation}`}</label>
                  </div>
                </div>
              )}

              <div className="flex justify-end mt-2 w-full">
                {!isFirstOne &&
                  // !timelineObj?.IsManual &&
                  timelineObj?.DynamicForm &&
                  !isForReport && (
                    <Button
                      sx={{
                        color: timelineObj?.FinalStatus?.ForegroundColor,
                        borderColor: timelineObj?.FinalStatus?.ForegroundColor,
                      }}
                      size="medium"
                      variant="outlined"
                      className="app_general_button_data app_success_button btn-sm "
                      onClick={() => {
                        handleDynamicFormClick(timelineObj?.DynamicForm);
                      }}
                    >
                      {`${timelineObj?.DynamicForm.Name}`}
                    </Button>
                  )}

                {!isFirstOne &&
                  (timelineObj.GpsLattitude < 0 ||
                    timelineObj.GpsLattitude > 0) &&
                  (timelineObj.GpsLongitude < 0 ||
                    timelineObj.GpsLongitude > 0) && (
                    <Button
                      sx={{
                        color: timelineObj?.FinalStatus?.ForegroundColor,
                        borderColor: timelineObj?.FinalStatus?.ForegroundColor,
                        marginLeft:
                          !isFirstOne &&
                          timelineObj?.DynamicForm &&
                          !isForReport
                            ? "10px"
                            : "0px",
                      }}
                      size="medium"
                      variant="outlined"
                      className="app_general_button_data app_success_button btn-sm "
                      onClick={() => {
                        window
                          .open(
                            getGoogleMapsLink(
                              timelineObj.GpsLattitude,
                              timelineObj.GpsLongitude,
                            ),
                            "_blank",
                          )
                          .focus();
                      }}
                    >
                      GPS
                    </Button>
                  )}
              </div>
            </div>
          </div>
        </div>
      </TimelineContent>
    </TimelineItem>
  );
};

// eslint-disable-next-line arrow-body-style
const StatusChangeItemForReport = ({
  timelineObj,
  isFirstOne,
  eventModel,
  hideSignatures,
  isOriginal,
  formResultsFormatting,
  hideModificationDate,
}) => {
  const changeDate = new Date(
    isFirstOne ? eventModel?.CreationDate : timelineObj?.ChangeDate,
  ).toLocaleString(undefined, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return (
    <div
      className="flex w-full"
      style={{
        border: "1px solid black",
        marginTop: "4px",
        borderRadius: "5px",
      }}
    >
      <div className="page-break" />
      <div
        style={{
          borderTopLeftRadius: "5px",
          borderBottomLeftRadius: "5px",
          minWidth: "20px",
          backgroundColor: isFirstOne
            ? timelineObj?.InitialStatus?.BackgroundColor
            : timelineObj?.FinalStatus?.BackgroundColor,
        }}
      />

      <div
        className="flex flex-col w-full"
        style={{ padding: "5px", width: "100%" }}
      >
        <label className="report_little_text">
          <b>{`${changeDate} - ${
            isFirstOne
              ? timelineObj?.InitialStatus?.Name
              : timelineObj?.FinalStatus?.Name
          } ${
            timelineObj.IsManual ? `(${localize.executed_manually})` : ""
          }`}</b>
        </label>

        <div className="w-full" style={{ display: "flex", gap: "10px" }}>
          <label className="report_little_text">
            <b>{`${localize.reported_by}: `}</b>
          </label>
          <label className="report_little_text">
            {isFirstOne ? eventModel?.CreatedBy : timelineObj.CreatedBy}
          </label>
        </div>

        {!isFirstOne && timelineObj?.Observation?.length > 0 && (
          <div className="w-full" style={{ display: "flex", gap: "10px" }}>
            <label className="report_little_text">
              <b>{`${localize.observations}: `}</b>
            </label>
            <label className="report_little_text">
              {timelineObj.Observation}
            </label>
          </div>
        )}
        {!isFirstOne && timelineObj?.DynamicForm && (
          <div className="w-full" style={{ marginTop: "10px" }}>
            <DynamicFormHeaderForReport
              dynamicForm={timelineObj?.DynamicForm}
              requiredForm
              eventId={eventModel?.Id}
              statusChangeId={timelineObj.Id}
              hideSignatures={hideSignatures}
              original={isOriginal}
              formResultsFormat={formResultsFormatting}
              hideModificationDate={hideModificationDate}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default function StateChangeTimeline({
  timelineData,
  firstStatusChange,
  eventModel,
  dynamicFormModel,
  setDynamicFormModel,
  isForReport,
  hideSignatures,
  isOriginal,
  canEditValues,
  formResultsFormatting,
  hideModificationDate,
}) {
  const [showModal, setShowModal] = useState(false);
  const [statusChangeId, setStatusChangeId] = useState(0);

  return (
    <>
      {showModal && (
        <ModalBackground
          onClickToCancel={() => {
            if (setDynamicFormModel) {
              setDynamicFormModel(getClearBasicModel());
            }

            setShowModal(false);
          }}
          onClickToSubmit={() => {
            // TODO: Do something for submit
          }}
          hideSubmitButton
          setShowModal={setShowModal}
          showModal={showModal}
          title={dynamicFormModel?.Name}
          cancelButtonText={localize.close}
          Component={
            <DynamicFormReview
              statusChangeId={statusChangeId}
              eventId={eventModel?.Id}
              dynamicFormModel={dynamicFormModel}
              allFieldsDisabled={!canEditValues}
              hideModificationDate={hideModificationDate}
            />
          }
        />
      )}

      {!isForReport ? (
        <Timeline
          sx={{
            [`& .${timelineOppositeContentClasses.root}`]: {
              flex: 0,
            },
          }}
        >
          {firstStatusChange && (
            <StatusChangeTimelineItem
              key={firstStatusChange?.Id}
              timelineObj={firstStatusChange}
              isFirstOne
              eventModel={eventModel}
            />
          )}

          {timelineData.map((timelineObj) => (
            <StatusChangeTimelineItem
              key={timelineObj.Id}
              setStatusChangeId={setStatusChangeId}
              timelineObj={timelineObj}
              setDynamicFormModel={setDynamicFormModel}
              setShowDynamicFormModal={setShowModal}
              isForReport={isForReport}
            />
          ))}
        </Timeline>
      ) : (
        <div className="w-full">
          {firstStatusChange && (
            <>
              <div className="page-break" />
              <StatusChangeItemForReport
                isFirstOne
                timelineObj={firstStatusChange}
                eventModel={eventModel}
                hideSignatures={hideSignatures}
                isOriginal={isOriginal}
                formResultsFormatting={formResultsFormatting}
                hideModificationDate={hideModificationDate}
              />
            </>
          )}

          {timelineData.map((timelineObj) => (
            <div key={timelineObj.Id}>
              <div className="page-break" />
              <StatusChangeItemForReport
                timelineObj={timelineObj}
                eventModel={eventModel}
                hideSignatures={hideSignatures}
                isOriginal={isOriginal}
                formResultsFormatting={formResultsFormatting}
                hideModificationDate={hideModificationDate}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
}
